// app/javascript/controllers/ui/manifesto/cursor_light_controller.js

import { Controller } from "@hotwired/stimulus"

/**
 * Cursor Light Controller
 *
 * Тонкий radial-gradient spotlight, который следует за курсором.
 * Элемент с контроллером становится относительным контейнером;
 * создаётся внутренний слой .mf-cursor-light__glow, который позиционируется
 * через CSS-переменные --mx, --my.
 *
 * @usedby _hero.html.erb, _final_cta.html.erb
 *
 * Usage:
 *   <section class="mf-section"
 *            data-controller="ui--manifesto--cursor-light"
 *            data-ui--manifesto--cursor-light-color-value="#6C4DFF"
 *            data-ui--manifesto--cursor-light-size-value="600">
 *     ...
 *   </section>
 *
 * CSS (в manifesto.css):
 *   .mf-cursor-light      { position: relative; isolation: isolate; }
 *   .mf-cursor-light__glow{ position:absolute; inset:0; pointer-events:none;
 *                            background: radial-gradient(var(--size,500px) at var(--mx,50%) var(--my,50%),
 *                              var(--clr, rgba(108,77,255,0.22)), transparent 60%); }
 */
export default class extends Controller {
  static values = {
    color: { type: String, default: "rgba(108,77,255,0.25)" },
    size: { type: Number, default: 520 }
  }

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
    if (matchMedia("(hover: none)").matches) return   // skip on touch

    this.element.classList.add("mf-cursor-light")
    this.glow = document.createElement("div")
    this.glow.className = "mf-cursor-light__glow"
    this.glow.style.setProperty("--clr", this.colorValue)
    this.glow.style.setProperty("--size", `${this.sizeValue}px`)
    this.glow.style.setProperty("--mx", "50%")
    this.glow.style.setProperty("--my", "50%")
    this.element.appendChild(this.glow)

    this.onMove = this.#onMove.bind(this)
    this.element.addEventListener("pointermove", this.onMove)
  }

  disconnect() {
    this.element.removeEventListener("pointermove", this.onMove)
    if (this.glow && this.glow.parentNode) this.glow.parentNode.removeChild(this.glow)
  }

  #onMove(e) {
    const rect = this.element.getBoundingClientRect()
    const x = ((e.clientX - rect.left) / rect.width) * 100
    const y = ((e.clientY - rect.top) / rect.height) * 100
    this.glow.style.setProperty("--mx", `${x}%`)
    this.glow.style.setProperty("--my", `${y}%`)
  }
}
